import React, { FC, useRef, useState } from 'react';
import Slider from 'react-slick';
import DictionaryTerm from '../../../../../@shared/dictionaryTerm';
import Card from './card';
import { TCardCarouselProps, TCardProps } from '../../../../types/dealerLocator.types';
import CarouselArrow from '../../../../../@shared/carouselArrow';
import CustomCarouselDots from '../../../../../@shared/customCarouselDots';
import Icon from '../../../../../@shared/icon';
import { iconSize } from '../../../../../../constants/icon.constants';
import { CarouselDirectionEnum } from '../../../../../../enums/carousel.enums';
import './styles.scss';
import Picture from '../../../../../@shared/picture';


const CardCarousel: FC<TCardCarouselProps> = (props: TCardCarouselProps) => {
    const { cards, distanceUnit, desktopImage, mobileImage} = props;
    const cardsLength = cards.length;
    const cardWidthRef = useRef<HTMLDivElement | null>(null);
    const [activeCard, updateActiveCardNumber] = useState<number>(1); // eslint-disable-line
    const [selectedDealerNumber, setSelectedDealerNumber] = useState(props?.value || '');

    const updateDealerNumber = (dealerNumber: string) => {
        setSelectedDealerNumber(dealerNumber);
        props.updateSelectedDealerNumber(dealerNumber);
    };

    const cardsMapper = (items: TCardProps[]): JSX.Element[] => {
        const isLarge = items.length < 3;
        const cardsArray = items.map((item) => (
            <Card
                {...item}
                selectedDealerNumber={selectedDealerNumber}
                updateSelectedDealerNumber={updateDealerNumber}
                isLarge={isLarge}
                distanceUnit={distanceUnit}
            />
        ));

        return cardsArray;
    };

    const settings = {
        arrows: true,
        infinite: false,
        variableWidth: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        dots: true,
        nextArrow: <CarouselArrow direction={CarouselDirectionEnum.NEXT} additionalCssClass={`preferred-dealer-carousel__arrow ${activeCard === cardsLength ? 'preferred-dealer-carousel__arrow--hidden' : ''}`} /> as any,
        prevArrow: <CarouselArrow direction={CarouselDirectionEnum.PREVIOUS} additionalCssClass={`preferred-dealer-carousel__arrow ${activeCard === 1 ? 'preferred-dealer-carousel__arrow--hidden' : ''}`} /> as any,
        dotsClass: 'preferred-dealer-card__dots',
        afterChange: (newIndex: number) => {
            updateActiveCardNumber(newIndex + 1);
        },
        appendDots: () => <CustomCarouselDots cardsCount={cardsLength} activeCard={activeCard} /> // eslint-disable-line
    };

    if (cardsLength === 0) {
        return (
            <div className="preferred-dealer-carousel__search-no-match">
                <Icon iconName="info-alert-notif-info" size={iconSize.xlg} extraClassName="dealer-info-icon" />
                <p className="preferred-dealer-carousel__search-no-match-title">
                    <DictionaryTerm keyword={'cnhi-formsDealersNoMatchesFoundTitle'} />
                </p>
                <p className="preferred-dealer-carousel__search-no-match-desc">
                    <DictionaryTerm keyword={'cnhi-formsDealersNoMatchesFoundDescription'} />
                </p>
            </div>
        );
    }

    return (
        <div className='preferred-dealer-carousel' ref={cardWidthRef}>
            <div className='preferred-dealer-carousel__bgWrapper'>
                <Picture
                    editorialImageProps={{
                        desktopImage: desktopImage,
                        mobileImage: mobileImage,
                        cssClassPictureEl: 'preferred-dealer-carousel__background',
                        desktopTransformation: 'Size1900',
                        mobileTransformation: 'Size1000'
                    }}
                />
                <p className='preferred-dealer-carousel__title'>
                    {cards.length} <DictionaryTerm keyword={'cnhi-formsDealersCardsCount'} />
                </p>
            </div>
            <Slider {...settings}>
                {cardsMapper(cards)}
            </Slider>
        </div>
    );
}

export default CardCarousel;
